import { useEffect, useState, useCallback } from 'react';
import {
  listAppConfig,
  updateAppConfig,
  AppConfigRow,
} from '../services/appConfig';
import { supabase } from '../lib/supabase';

export function useAppConfig() {
  const [rows, setRows] = useState<AppConfigRow[]>([]);
  const [loading, setLoading] = useState(true);
  const [savingKey, setSavingKey] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setRows(await listAppConfig());
    } catch (e: any) {
      setError(e?.message || 'Erreur de chargement');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
    const channel = supabase
      .channel('app-config-rt')
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'app_config' },
        () => reload()
      )
      .subscribe();
    return () => {
      supabase.removeChannel(channel);
    };
  }, [reload]);

  const save = useCallback(
    async (key: string, newValue: number | boolean | string) => {
      const row = rows.find(r => r.key === key);
      if (!row) return;
      if (row.value === newValue) return;
      setSavingKey(key);
      try {
        await updateAppConfig(key, row.value, newValue, row.label);
        // Optimistic update — RT remplacera ensuite
        setRows(prev => prev.map(r => (r.key === key ? { ...r, value: newValue } : r)));
      } finally {
        setSavingKey(null);
      }
    },
    [rows]
  );

  return { rows, loading, savingKey, error, save, reload };
}
